import React, { useCallback, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import StarRating from 'sushiweb/StarRating';
import { OrderBill } from '../../../popups';
import './PaymentDetailV1.scss';
import { Modal, ModalHeader } from '../../../../UiKit';
import {
  ORDER_EVENTS,
  sendOrderModalEvents,
} from '../../../../helpers/analytics/order.analytics';
import { Check, CheckCheck, CheckLine, CircleCheckBig } from 'lucide-react';

const PaymentDetailModal = (props) => {
  const {
    order,
    isModalVisible,
    paymentStatus,
    closePopup,
    customerRating,
    setCustomerRating,
  } = props;

  if (!order.order_id) return null;

  return (
    <Modal
      isVisible={isModalVisible}
      padding={0}
      paddingTop={'1rem'}
      type='huge'
      height='100%'
      maxHeight='80vh'
      overflowY='hidden'
      titleComponent={
        <div
          css={`
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 0.5rem;
          `}
        >
          <ModalHeader
            title='Items & Billing'
            label={paymentStatus}
            bgColor={paymentStatus === 'Success' ? '#F6F9FD' : '#F7EBEC'}
            textColor={paymentStatus === 'Success' ? '#0366D6' : '#EE556A'}
            handleClose={closePopup}
          />
          {customerRating != 'loading' && (
            <StarRating
              value={customerRating ? customerRating : ''}
              align='right'
              ratingColor={'#4db545'}
            />
          )}
        </div>
      }
      showCloseIcon={false}
      handleClose={closePopup}
      containerStyles={{
        margin: '16px 0 20px 0',
        overflowY: 'auto',
      }}
      component={
        <OrderBill
          orderId={order.order_id}
          setCustomerRating={setCustomerRating}
        />
      }
    />
  );
};

export const PaymentDetailV1 = (props) => {
  return (
    <div className='paymentDetailContainerV1 tw-w-full tw-h-full'>
      {!props?.order ? (
        <Shimmer height='100%' width='100%' />
      ) : (
        <PaymentComp {...props} />
      )}
    </div>
  );
};

const PaymentComp = ({ order = null, orderId, userId }) => {
  const [isModalVisible, setModalVisibility] = useState(false);
  const [customerRating, setCustomerRating] = useState('loading');

  const showModal = useCallback(() => {
    sendOrderModalEvents(ORDER_EVENTS.ORDER_BILL_MODAL_OPEN, orderId, userId);
    setModalVisibility(true);
  }, [orderId, userId]);

  const closePopup = useCallback(() => {
    sendOrderModalEvents(ORDER_EVENTS.ORDER_BILL_MODAL_CLOSE, orderId, userId);
    setModalVisibility(false);
  }, [orderId, userId]);

  const paymentMethodImages = useCallback((images) => {
    if (typeof images === 'object') {
      images = Object.values(images);
    }
    if (!images?.length) return;
    return images.map((image, index) => {
      return (
        <React.Fragment key={`${image}-${index}`}>
          <div className='tw-h-9'>
            <img src={image} alt='' width='100%' height='100%' />
          </div>
          {images.length > 1 && index !== images.length - 1 && (
            <span className='plusIcon'>+</span>
          )}
        </React.Fragment>
      );
    });
  }, []);

  if (!order) return null;

  const paymentStatus =
    order && order.payment_status === 1 ? 'Success' : 'Failure';

  return (
    <div className='paymentInfo tw-flex tw-w-full' data-dd-privacy='mask'>
      <div className='tw-w-full tw-flex tw-flex-col tw-justify-between tw-h-full'>
        <div className='tw-flex tw-justify-between tw-items-center'>
          <div className='tw-flex tw-items-center tw-gap-2'>
            {paymentMethodImages(order.payment_method_images)}
            <div className='tw-whitespace-nowrap tw-leading-tight tw-text-[14px] tw-font-medium tw-text-zinc-600 '>
              Payment: {order.currency}
              {order.total_amount}
            </div>
          </div>

          {/* Payment status */}
          <span
            className={`paymentStatus ${paymentStatus} tw-border tw-border-solid ${
              order.payment_status === 1
                ? '!tw-border-green-400 !tw-bg-green-100/40'
                : '!tw-border-red-300 !tw-bg-red-100'
            } tw-text-[1.3rem] tw-h-full tw-max-h-10 tw-font-medium tw-flex tw-items-center tw-gap-2`}
          >
            {paymentStatus}
            {order && order.payment_status === 1 ? (
              <Check
                size={16}
                strokeWidth={2.3}
                className='tw-mt-px tw-ml-px'
              />
            ) : null}
          </span>

          {order.payment_card_types && order.payment_card_types.length ? (
            <p>{order.payment_card_types[0]}</p>
          ) : null}
        </div>
        <div className='tw-flex tw-items-center tw-justify-between'>
          <span
            className='tw-text-300 tw-font-medium tw-leading-none tw-text-green-700 tw-cursor-pointer tw-whitespace-nowrap'
            onClick={showModal}
          >
            View Order & Bill
          </span>
        </div>
      </div>

      {isModalVisible && (
        <PaymentDetailModal
          order={order}
          isModalVisible={isModalVisible}
          paymentStatus={paymentStatus}
          closePopup={closePopup}
          customerRating={customerRating}
          setCustomerRating={setCustomerRating}
        />
      )}
    </div>
  );
};
